import { Phone, Calendar, MapPin, Clock } from 'lucide-react';

const HERO_VIDEO = "https://customer-assets.emergentagent.com/job_poly-laundry-pro/artifacts/bxq6uodt_8756884-uhd_4096_2160_25fps.mp4";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_7a187c08-1566-4a5d-94a6-902036d37fa8/artifacts/oin9oc2t_Untitled%20design%20%2814%29.png";

export default function HeroSection() {
  const scrollTo = (e, id) => {
    e.preventDefault();
    const el = document.querySelector(id);
    if (el) {
      const offset = 80;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden" data-testid="hero-section">
      {/* Fallback background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(https://customer-assets.emergentagent.com/job_poly-laundry-pro/artifacts/g16y2r3t_IMG_9675.png)` }}
      />

      {/* Video Background */}
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className="absolute inset-0 w-full h-full object-cover"
        data-testid="hero-video"
      >
        <source src={HERO_VIDEO} type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="absolute inset-0 hero-overlay" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-32 w-full">
        <div className="max-w-2xl">
          {/* Poly Clean Center name */}
          <h2 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight mb-3 animate-fade-in-up drop-shadow-lg" data-testid="hero-brand-name">
            Poly Clean Center
          </h2>
          <div className="mb-6 animate-fade-in-up">
            <span className="text-white/80 text-sm font-medium">Serving Mountain Home & Surrounding Area Since 1963</span>
          </div>

          <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.1] tracking-tight mb-6 animate-fade-in-up animation-delay-200" data-testid="hero-headline">
            Fast, Fresh & Clean{' '}
            <span className="text-poly-blue-light">Laundry Service</span>{' '}
            in Mountain Home & Surrounding Area
          </h1>

          <p className="text-lg sm:text-xl text-white/85 leading-relaxed mb-8 max-w-xl animate-fade-in-up animation-delay-400" data-testid="hero-subtext">
            Your trusted local laundromat for residential and commercial laundry. 
            Enjoy free pickup & delivery, professional wash & fold, and 
            convenient self-service options.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-10 animate-fade-in-up animation-delay-600">
            <a
              href="#contact"
              onClick={(e) => scrollTo(e, '#contact')}
              className="inline-flex items-center justify-center gap-2 bg-poly-orange hover:bg-orange-600 text-white font-bold text-base px-8 py-4 rounded-full transition-all shadow-lg shadow-orange-500/30 hover:shadow-orange-500/50 hover:-translate-y-1 hover:scale-105 active:scale-95 pulse-glow"
              data-testid="hero-cta-schedule"
            >
              <Calendar className="w-5 h-5" />
              Schedule Free Pickup
            </a>
            <a
              href="tel:8704254295"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 text-white font-bold text-base px-8 py-4 rounded-full transition-all hover:-translate-y-1"
              data-testid="hero-cta-call"
            >
              <Phone className="w-5 h-5" />
              Call (870) 425-4295
            </a>
          </div>

          {/* Trust signals */}
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 text-white/70 text-sm animate-fade-in-up animation-delay-800">
            <span className="flex items-center gap-2 bg-amber-500/20 backdrop-blur-sm border border-amber-400/30 text-amber-200 font-semibold px-3 py-1.5 rounded-full text-xs">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
              Best Laundromat 2025 — Best of Twin Lakes
            </span>
            <span className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-poly-blue-light" />
              715 South Street, Mountain Home, AR
            </span>
            <span className="flex items-center gap-2">
              <Clock className="w-4 h-4 text-poly-blue-light" />
              Mon-Fri 8AM-5PM | Sat 8AM-4PM
            </span>
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent" />
    </section>
  );
}
